import React from "react";
import { Box, Typography, Select, MenuItem, FormControl, Divider } from "@mui/material";
import AppDatePicker from "../../../common/app-date-picker";
import typography from "../../../cssUtils/typography";
import { selectFieldSx, labelSx, sectionLabelSx } from "../utils";

// Shared "Active Window" section — identical between WorkflowEdit (non-recurring
// nodebots) and CustomChatbotEdit. Callers own all the state; this just renders it and
// calls back on change. Requires an ancestor <LocalizationProvider> (see WorkflowEdit/
// CustomChatbotEdit) for AppDatePicker to work.
const ActiveWindowEditor = ({
  useDateConstraints,
  activeStartDate,
  activeEndDate,
  errors,
  onUseDateConstraintsChange,
  onActiveStartDateChange,
  onActiveEndDateChange,
}) => (
  <>
    <Divider sx={{ mb: 3 }} />
    <Typography sx={sectionLabelSx}>Active Window</Typography>
    <Box sx={{ display: "flex", gap: 3, mb: 3 }}>
      <Box sx={{ flex: 1 }}>
        <Typography sx={labelSx}>Run Schedule</Typography>
        <FormControl fullWidth size="small">
          <Select
            value={useDateConstraints ? "limited" : "forever"}
            onChange={(e) => onUseDateConstraintsChange(e.target.value === "limited")}
            sx={selectFieldSx}
          >
            <MenuItem value="forever" sx={{ ...typography.bodyLarge }}>Always on</MenuItem>
            <MenuItem value="limited" sx={{ ...typography.bodyLarge }}>Limit by date range</MenuItem>
            {/* UI-only preview for now — not implemented, same pattern as the disabled
                trigger-type entries in ENTRY_TYPE_GROUPS (../utils.js) */}
            <MenuItem value="business_hours" disabled sx={{ ...typography.bodyLarge }}>
              Business hours only
            </MenuItem>
            <MenuItem value="custom_days_time" disabled sx={{ ...typography.bodyLarge }}>
              Custom days and time
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ flex: 1 }} />
    </Box>

    {useDateConstraints && (
      <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
        <Box sx={{ flex: 1 }}>
          <Typography sx={labelSx}>Active From</Typography>
          <AppDatePicker
            value={activeStartDate}
            onChange={onActiveStartDateChange}
            error={!!errors.activeStartDate}
            helperText={errors.activeStartDate}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography sx={labelSx}>Active Until</Typography>
          <AppDatePicker
            value={activeEndDate}
            onChange={onActiveEndDateChange}
            minDate={activeStartDate || undefined}
            error={!!errors.activeEndDate}
            helperText={errors.activeEndDate}
          />
        </Box>
      </Box>
    )}
  </>
);

export default ActiveWindowEditor;
